module.exports = __webpack_public_path__ + "static/media/picto-speech-bubble-filled-blue.e5f53d3d.svg";